export const userSignUp = (user) => {
   return {
      type: "SIGNUP_USER",
      payload: user,
   };
};
export const userSignIn = (user) => {
   return {
      type: "SIGNIN_USER",
      payload: user,
   };
};
export const userHeadlessSignIn = () => {
   return {
      type: "HEADLESS_SIGNIN_USER",
   };
};
export const userSignOut = () => {
   return {
      type: "SIGNOUT_USER",
   };
};
export const userSignUpSuccess = (authUser) => {
   return {
      type: "SIGNUP_USER_SUCCESS",
      payload: authUser,
   };
};

export const userSignInSuccess = (authUser) => {
   return {
      type: "SIGNIN_USER_SUCCESS",
      payload: authUser,
   };
};

export const userSignInFailure = () => {
   return {
      type: "SIGNIN_USER_FAILURE",
   };
};

export const userSignOutSuccess = () => {
   return {
      type: "SIGNOUT_USER_SUCCESS",
   };
};

export const userSignOutFailure = () => {
   return {
      type: "SIGNOUT_USER_FAILURE",
   };
};

export const showAuthMessage = (message) => {
   return {
      type: "SHOW_MESSAGE",
      payload: message,
   };
};
export const hideMessage = () => {
   return {
      type: "HIDE_MESSAGE",
   };
};

export const userGoogleSignIn = () => {
   return {
      type: "SIGNIN_GOOGLE_USER",
   };
};
export const userGoogleSignInSuccess = (authUser) => {
   return {
      type: "SIGNIN_GOOGLE_USER_SUCCESS",
      payload: authUser,
   };
};
export const userFacebookSignIn = () => {
   return {
      type: "SIGNIN_FACEBOOK_USER",
   };
};
export const userFacebookSignInSuccess = (authUser) => {
   return {
      type: "SIGNIN_FACEBOOK_USER_SUCCESS",
      payload: authUser,
   };
};
export const setInitUrl = (url) => {
   return {
      type: "INIT_URL",
      payload: url,
   };
};
export const userTwitterSignIn = () => {
   return {
      type: "SIGNIN_TWITTER_USER",
   };
};
export const userTwitterSignInSuccess = (authUser) => {
   return {
      type: "SIGNIN_TWITTER_USER_SUCCESS",
      payload: authUser,
   };
};
export const userGithubSignIn = () => {
   return {
      type: "SIGNIN_GITHUB_USER",
   };
};
export const userGithubSignInSuccess = (authUser) => {
   return {
      type: "SIGNIN_GITHUB_USER_SUCCESS",
      payload: authUser,
   };
};
export const showAuthLoading = () => {
   return {
      type: "ON_SHOW_LOADING",
   };
};
export const setLoggingIn = (loggingIn) => {
   return {
      type: "SET_LOGGING_IN",
      payload: loggingIn,
   };
};
export const setOrganization = (organization) => {
   return {
      type: "SET_ORGANIZATION",
      payload: organization,
   };
};
export const setCurrentCompany = (currentCompany) => {
   return {
      type: "SET_COMPANY",
      payload: currentCompany,
   };
};
export const setCurrentDepartment = (currentDepartment) => {
   return {
      type: "SET_CURRENT_DEPARTMENT",
      payload: currentDepartment,
   };
};

export const hideAuthLoading = () => {
   return {
      type: "ON_HIDE_LOADING",
   };
};

export const setBackUrl = (url) => {
   return {
      type: "SET_BACK_URL",
      payload: url,
   };
};
